<div class="upload-document-dialog fs-dialog">
  <header class="upload-document-dialog-header-wrapper">
    <h2 class="dialog-title">{{ dialogTitle }}</h2>
    <button
      mat-icon-button
      type="button"
      class="close-dialog-button"
      aria-label="Close"
      (click)="close()"
    >
      <mat-icon class="close-dialog-icon material-icons-outlined"
        >close</mat-icon
      >
    </button>
  </header>

  <mat-dialog-content>
    <div
      class="upload-zone"
      [class.dragging]="isDragging()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <input
        type="file"
        id="file-input"
        class="file-input"
        [multiple]="allowsMultipleFiles"
        accept=".pdf,.xml,.doc,.docx"
        (change)="onFileSelected($event)"
      />
      <label for="file-input" class="upload-zone-content">
        <mat-icon class="upload-icon material-icons-outlined"
          >upload_file</mat-icon
        >
        <span class="upload-text">
          <a class="upload-link">Link</a> or drag and drop
        </span>
        <small class="formats-list">PDF, XML, Doc (max. 200MB each)</small>
      </label>
    </div>

    @for (uploadedFile of files(); track $index) {
      <div
        class="uploaded-file-wrapper"
        [class.upload-error]="
          uploadedFile.serverMessage && !uploadedFile.uploadSuccess
        "
        [class.upload-success]="uploadedFile.uploadSuccess"
      >
        <div class="file-info-wrapper">
          <mat-icon class="uploaded-file-icon material-icons-outlined"
            >upload_file</mat-icon
          >
          <div class="file-metadata-wrapper">
            <span class="file-name">{{ uploadedFile.file.name }}</span>
            @if (uploadedFile.uploadError) {
              <span class="error-message"
                >{{ uploadedFile.uploadError }} • Failed</span
              >
            } @else {
              <span class="upload-status">
                {{ uploadedFile.file.size / 1000 | number: "1.0-0" }}kb •
                <span class="upload-status-text">
                  {{ uploadedFile.progress === 100 ? "Complete" : "Loading" }}
                </span>
              </span>
            }
            @if (uploadedFile.uploadError) {
              <mat-progress-bar
                mode="determinate"
                [value]="uploadedFile.progress"
                class="error-progress-bar"
              ></mat-progress-bar>
            } @else if (!uploadedFile.uploadSuccess) {
              <mat-progress-bar
                mode="determinate"
                [value]="uploadedFile.progress"
              ></mat-progress-bar>
            }
          </div>
          <button
            mat-icon-button
            type="button"
            class="delete-btn"
            (click)="removeFile($index)"
          >
            <mat-icon class="delete-icon material-icons">delete</mat-icon>
          </button>
        </div>

        @if (showDocumentTypeSelector) {
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded document-type-select no-subscript-wrapper"
          >
            <mat-select
              [formControl]="uploadedFile.docType"
              required
              disableOptionCentering
              placeholder="Type of Document"
              [disabled]="
                isLoadingDocumentTypes() ||
                documentTypesError() ||
                (uploadedFile.uploadSuccess ?? false)
              "
            >
              @if (isLoadingDocumentTypes()) {
                <mat-option disabled>Loading document types...</mat-option>
              } @else if (documentTypesError()) {
                <mat-option disabled>Failed to load document types</mat-option>
              } @else {
                @for (docType of documentTypeOptions(); track docType) {
                  <mat-option [value]="docType">{{ docType }}</mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    }
    @if (isVendorManualUploadMode) {
      <form
        [formGroup]="completedDatesForm"
        class="completed-dates-form no-subscript-wrapper"
      >
        <div class="field-wrapper">
          <label class="field-label" for="vendor-order-completed-date">
            Vendor Order Completed Date
          </label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-date"
            [class.field-error]="isVendorDateMissing()"
          >
            <input
              matInput
              [matDatepicker]="vendorCompletedDatePicker"
              formControlName="vendorOrderCompletedDate"
              id="vendor-order-completed-date"
              placeholder="Select Date"
            />
            <mat-datepicker-toggle matSuffix [for]="vendorCompletedDatePicker">
              <mat-icon matDatepickerToggleIcon class="material-icons-outlined">
                calendar_today
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker
              #vendorCompletedDatePicker
              startView="month"
            ></mat-datepicker>
          </mat-form-field>
          @if (isVendorDateMissing()) {
            <span class="date-error-message">{{
              vendorDateRequiredMessage
            }}</span>
          }
        </div>

        <div class="field-wrapper">
          <label class="field-label" for="client-order-completed-date">
            Client Order Completed Date
          </label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-date"
          >
            <input
              matInput
              [matDatepicker]="clientCompletedDatePicker"
              formControlName="clientOrderCompletedDate"
              id="client-order-completed-date"
              placeholder="Select Date"
            />
            <mat-datepicker-toggle matSuffix [for]="clientCompletedDatePicker">
              <mat-icon matDatepickerToggleIcon class="material-icons-outlined">
                calendar_today
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker
              #clientCompletedDatePicker
              startView="month"
            ></mat-datepicker>
          </mat-form-field>
        </div>
      </form>
    }
  </mat-dialog-content>

  <div class="upload-document-dialog-actions-wrapper">
    <button
      mat-flat-button
      color="primary"
      class="save-button"
      [disabled]="!canUpload || isUploading()"
      (click)="upload()"
    >
      {{ uploadButtonText }}
    </button>
    <button
      mat-stroked-button
      class="cancel-button"
      [disabled]="isUploading()"
      (click)="close()"
    >
      Cancel
    </button>
  </div>
</div>
